import React, { useState, useEffect } from 'react';
import { trackMangaView, trackPageView } from '../../../utils/analytics';
import SEOHead from '../../SEO/SEOHead';
import './MangaDetailPage.css';

const MangaDetailPage = ({ mangaId }) => {
  const [mangaDetail, setMangaDetail] = useState(null);

  useEffect(() => {
    const fetchMangaDetail = async () => {
      try {
        console.log(`Fetching manga details for mangaId: ${mangaId}`);
        const response = await fetch(`/api/manga/${mangaId}`);
        if (!response.ok) {
          // Log response error if not OK (non-2xx status)
          console.error('Error fetching manga details:', response.status);
          return; // Return early if there is an error
        }
        const data = await response.json();
        console.log('Manga details fetched:', data);
        setMangaDetail(data);
        if (data?.title) {
          const pageTitle = `ChibiDash | ${data.title} Manga`;
          document.title = pageTitle;
          trackPageView(`/manga-home/manga/${mangaId}`, pageTitle);
          trackMangaView(mangaId, data.title);
        }
      } catch (error) {
        // Log any fetch errors (network errors, etc.)
        console.error('Error fetching data:', error);
      }
    };

    if (mangaId) {
      fetchMangaDetail();
    }
  }, [mangaId]);

  if (!mangaDetail) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="manga-detail-page">
      <SEOHead
        title={`ChibiDash | ${mangaDetail.title} Manga`}
        description={mangaDetail.description?.substring(0, 160) || `Read ${mangaDetail.title} on ChibiDash`}
        path={`/manga-home/manga/${mangaId}`}
        image={mangaDetail.image}
      />
      <h1 className="manga-detail-title">{mangaDetail.title}</h1>
      <img src={mangaDetail.image} alt={mangaDetail.title} className="manga-detail-image" />
      <p>{mangaDetail.description}</p>
      <div className="manga-detail-chapters">
        <h2>Chapters</h2>
        <ul>
          {mangaDetail.chapters.map((chapter) => (
            <li key={chapter.id}>{chapter.title}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MangaDetailPage;
